import onSubmitStart from './onSubmitStart';
import onUpdateFieldValidate from './onUpdateFieldValidate';
import onValidateStart from './onValidateStart';

export default [onSubmitStart, onUpdateFieldValidate, onValidateStart];
